//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let token = localStorage.getItem("token-admin")
export default {
  name: "NewRegulasi",
  data: function() {
    return {
      data: {},
      id: '',
      selectFile: '',
      theFile: {},
      ctgOption:[
        {value:'1', label:'rancangan peraturan'},
        // {value:'2', label:'naskah akademik'},
        {value:'3', label:'peraturan'},
      ],
      typeOption:[
        {value:'1', label:'UU'},
        {value:'2', label:'PP'},
        {value:'3', label:'PERKA'},
        {value:'4', label:'SK'},
      ]
    };
  },
  mounted() {
    this.id = this.$route.params.id
    if(this.id != -1){
      this.$http.get('/regulasi_byid/'+ this.id, {
        headers: { Authorization: "Bearer " + token}
      })
      .then (result => {
        this.data = result.data
      })
    }
  },
  methods: {
    chgFile(){
      if(this.$refs.file.files[0])
        this.selectFile = this.$refs.file.files[0].name
      else
        this.selectFile = ''
    },
    
    onSubmit() {
      this.$refs.name.validate();
      this.$refs.desc.validate();
      this.$refs.ctgr.validate();
      this.$refs.type.validate();
      if (
        this.$refs.name.hasError ||
        this.$refs.desc.hasError||
        this.$refs.ctgr.hasError||
        this.$refs.type.hasError
      ) {
        this.formHasError = true;
      } 
      else {
        if (this.data.id) {
          this.data.updatedBy = this.$store.state.currentAdmin.username
          this.data.updatedDate = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
          this.$http
            .put(
              "/update_regulasi/" + this.id, this.data,{
                headers: { Authorization: "Bearer " + token}
              })
            .then((result) => {
              this.upload(this.data.id)
            });
        } else {
          this.data.createdBy = this.$store.state.currentAdmin.username
          this.$http
            .post("/new_regulasi/", this.data, {
              headers: { Authorization: "Bearer " + token}
            })
            .then((result) => {
              this.upload(result.data)
            });
        }
      }
    },
    upload(id){
        this.theFile = this.$refs.file.files[0];
        if(this.theFile){
          var data = {file: this.theFile.name}
          var formData = new FormData();
          formData.append("file", this.theFile);
          formData.append("folder", "regulation/");
          this.$http
            .post("/upload.php", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((result) => {
              this.$http
                .put( "/update_regulasi/" + id, data,{
                  headers: { Authorization: "Bearer " + token}
                })
                .then((result) => {
                  
                });
            })
        }
        this.$router.push("/admin/regulasi");
        this.$q.notify({
          icon: "done",
          color: "positive",
          message: "Saved",
        });
    }
  },
};
